"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonDropdown = _interopRequireDefault(require("../dropdown/ButtonDropdown"));

var TreeOptions = function TreeOptions(props) {
  var treeOptions = props.treeOptions,
      className = props.className;

  if ((0, _isEmpty2.default)(treeOptions)) {
    return null;
  }

  var dropdownClasses = (0, _classnames.default)('width-250', 'padding-10', className);

  var customDropdown = /*#__PURE__*/_react.default.createElement("div", {
    className: dropdownClasses
  }, treeOptions);

  return /*#__PURE__*/_react.default.createElement(_ButtonDropdown.default, {
    title: /*#__PURE__*/_react.default.createElement("span", {
      className: "rioglyph rioglyph-option-vertical",
      "aria-hidden": "true"
    }),
    bsStyle: 'muted',
    customDropdown: customDropdown,
    className: 'TreeHeaderOptions',
    pullRight: true,
    iconOnly: true
  });
};

TreeOptions.displayName = 'TreeOptions';
TreeOptions.defaultProps = {
  treeOptions: []
};
TreeOptions.propTypes = {
  treeOptions: _propTypes.default.arrayOf(_propTypes.default.node),
  className: _propTypes.default.string
};
var _default = TreeOptions;
exports.default = _default;